"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylesConfig = exports.componentConfig = void 0;
var componentConfig = exports.componentConfig = {
  icon: {
    savedIconClassName: 'fuse-save__icon--saved',
    sizes: ['small', 'medium']
  },
  label: {
    color: 'var(--color-global-black)',
    size: '1',
    tag: 'span',
    type: 'paragraph'
  }
};
var stylesConfig = exports.stylesConfig = {
  styledLabel: {
    margin: '0 0 0 var(--spacing-global-space3)'
  },
  styledSave: {
    hoverIconOutlineColor: 'var(--color-brand-mid)',
    hoverSavedIconOutlineColor: 'var(--color-brand-dark)',
    padding: 'var(--spacing-global-space2) var(--spacing-global-space1)'
  }
};